export { FormGroup as default } from '@material-ui/core';
